import React, { useState, useEffect } from 'react';
import Logo from '../../images/logo.png'
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';
import API from '../../api/api';
import AuthLayout from './AuthLayout';

const FireApi = new API();

const Logout = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  const handleLogout = e => {
    e.preventDefault();

    FireApi.endpoints.authenticationLogout.create({})
      .then(() => {
        window.location.replace('/auth/login');
      })
      .catch(() => {
        // Even if logout fails, redirect to login
        window.location.replace('/auth/login');
      });
  };

  if (loading) {
    return null;
  }

  return (
    <AuthLayout
      logo={Logo}
      logoAlt="FireCore"
      title="Abmelden"
      subtitle="Möchten Sie sich wirklich abmelden?"
    >
      <div className="authenticate-buttons-logout">
        <Button onClick={handleLogout} variant="contained" className="authenticate-submit">
          Abmelden
        </Button>
      </div>
      <Button
        component={RouterLink}
        to="/"
        variant="outlined"
        className="authenticate-secondary"
      >
        Zurück
      </Button>
    </AuthLayout>
  );
};

export default Logout;
